// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/document-chart-bar.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/document-chart-bar'

import { Icon, type IconComponentProps } from '../icon'

export const DocumentChartBarIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
